import React from 'react'
import { useIntl } from 'react-intl'
import Label from 'LuxKit/Label'

interface Props {
  offer: App.MerchandiseOffer
}

function MerchandiseFreeShippingLabel({ offer }: Props) {
  const intl = useIntl()

  if (!offer.hasFreeShipping) {
    return null
  }

  return <Label kind="tertiary" variant="highlight">
    {intl.formatMessage({
      id: 'r4OinbkHXf',
      defaultMessage: 'Free shipping',
      description: 'Label shown when merchandise offer has free shipping',
    })}
  </Label>
}

export default MerchandiseFreeShippingLabel
